export class SubmissionComment {
    id?: string;
    status: string;
    submissionComment: string;
    submissionId: string;
}